import { render, staticRenderFns } from "./DealPage.vue?vue&type=template&id=57d09f84&scoped=true"
import script from "./DealPage.vue?vue&type=script&lang=js"
export * from "./DealPage.vue?vue&type=script&lang=js"
import style0 from "./DealPage.vue?vue&type=style&index=0&id=57d09f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d09f84",
  null
  
)

/* custom blocks */
import block0 from "./DealPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports